import Vue from "vue";

import EntriesList from "./DrawingEntries.vue";

export function load() {
    const selector = "entries-list";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(EntriesList, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
